var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundedRectangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 205 204",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M204.29 203.359H0.290039V63.6191C0.311208 46.917 6.95549 30.905 18.7657 19.0948C30.5759 7.28459 46.5879 0.640309 63.29 0.619141H204.29V203.359ZM26.29 177.359H178.29V26.6191H63.29C53.477 26.6191 44.0659 30.5173 37.1271 37.4562C30.1882 44.395 26.29 53.8061 26.29 63.6191V177.359Z",
    fill: "#231F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedRectangle);
export default __webpack_public_path__ + "static/media/rounded-rectangle.8305b8a040dca74950b5a7f610302fbb.svg";
export { ForwardRef as ReactComponent };